<template>
  <div class="attendance-container">
    <div class="page-header">
      <div class="breadcrumb">ນັກຮຽນ / <span>ບັນທຶກການຂາດຮຽນ (ວັນທີ {{ formattedDate }})</span></div>
      <div class="header-content">
        <h1>ບັນທຶກການຂາດຮຽນ</h1>
        <p>ກວດສອບ ແລະ ບັນທຶກການມາຮຽນຂອງນັກຮຽນປະຈຳວັນ</p>
      </div>
    </div>

    <div class="panel filter-panel">
      <div class="panel-head">
        <h3><i class="fas fa-filter"></i> ເງື່ອນໄຂການຄັດກອງ</h3>
      </div>
      <div class="panel-body">
        <div class="field-row-4">
          <div class="form-group">
            <label>ວັນທີ</label>
            <input type="text" v-model="dateText" @input="handleDateInput" placeholder="dd/mm/yyyy" inputmode="numeric" maxlength="10">
          </div>
          <div class="form-group">
            <label>ຊັ້ນຮຽນ</label>
            <select v-model="filters.grade" @change="fetchData">
              <option value="">-- ເລືອກຊັ້ນ --</option>
              <option v-for="item in classList" :key="item.value" :value="item.value">{{ item.text }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>ຫ້ອງຮຽນ</label>
            <select v-model="filters.room_no" @change="fetchData">
              <option v-for="n in 20" :key="n" :value="n">ຫ້ອງ {{ n }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>ສົກຮຽນ</label>
            <select v-model="filters.academicYear" @change="fetchData">
              <option v-for="item in accdList" :key="item.value" :value="item.text">{{ item.text }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="panel mt-4 table-panel" v-if="students.length > 0">
      <div class="panel-head">
        <h3><i class="fas fa-list-check"></i> ລາຍຊື່ນັກຮຽນ ({{ students.length }} ຄົນ)</h3>
        <div class="attendance-summary">
          <span class="badge present">ມາ: {{ stats.present }}</span>
          <span class="badge absent">ຂາດ: {{ stats.absent }}</span>
          <span class="badge leave">ລາ: {{ stats.leave }}</span>
        </div>
      </div>
      <div class="panel-body">
        <div class="table-wrap">
          <table class="attendance-table">
            <thead>
              <tr>
                <th width="60">ລຳດັບ</th>
                <th width="120">ລະຫັດ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <th class="text-center" width="250">ສະຖານະການມາຮຽນ</th>
                <th>ໝາຍເຫດ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, index) in students" :key="s._id">
                <td>{{ index + 1 }}</td>
                <td><span class="asset-code">{{ s.student_id }}</span></td>
                <td><strong>{{ s.firstNameLao }} {{ s.familyNameLao }}</strong></td>
                <td class="text-center">
                  <div class="status-selector">
                    <label class="status-btn p" :class="{active: s.status === 'P'}">
                      <input type="radio" v-model="s.status" value="P"> ມາ
                    </label>
                    <label class="status-btn a" :class="{active: s.status === 'A'}">
                      <input type="radio" v-model="s.status" value="A"> ຂາດ
                    </label>
                    <label class="status-btn l" :class="{active: s.status === 'L'}">
                      <input type="radio" v-model="s.status" value="L"> ລາ
                    </label>
                  </div>
                </td>
                <td>
                  <input type="text" v-model="s.remarks" placeholder="..." class="remarks-input">
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="form-actions-wrapper mt-4">
          <button class="btn-save" @click="saveAttendance" :disabled="submitting">
            <i class="fas" :class="submitting ? 'fa-spinner fa-spin' : 'fa-save'"></i>
            {{ submitting ? 'ກຳລັງບັນທຶກ...' : 'ບັນທຶກການມາຮຽນ' }}
          </button>
          <button class="btn-export" @click="exportToExcel" :disabled="students.length === 0">
            <i class="fas fa-file-excel"></i> ສົ່ງອອກ Excel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';
import * as XLSX from 'xlsx';

export default {
  name: 'AttendancePage',
  data() {
    return {
      submitting: false,
      filters: {
        date: new Date().toISOString().substr(0, 10),
        school_id:  '',
        grade: '',
        room_no: 1,
        academicYear: '2025-2026'
      },
      students: [],
      classList: [],
      accdList: [],
      user: {},
      dateText: ''
    }
  },
  computed: {
    stats() {
      return {
        present: this.students.filter(s => s.status === 'P').length,
        absent: this.students.filter(s => s.status === 'A').length,
        leave: this.students.filter(s => s.status === 'L').length
      }
    },
    formattedDate() {
      if (!this.filters.date) return '';
      const [year, month, day] = this.filters.date.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  async mounted() {
    this.user = JSON.parse(localStorage.getItem("user-info") || "{}");
    this.dateText = this.formattedDate;
    await this.fetchClassList();
    await this.fetchAccdList();

  },
  methods: {
    handleDateInput() {
      const digits = this.dateText.replace(/\D/g, '').slice(0, 8);
      let formatted = digits;
      if (digits.length > 4) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
      else if (digits.length > 2) formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}`;
      this.dateText = formatted;

      if (digits.length === 8) {
        const day = digits.slice(0, 2), month = digits.slice(2, 4), year = digits.slice(4, 8);
        this.filters.date = `${year}-${month}-${day}`;
        this.fetchData();
      }
    },
    async fetchClassList() {
      const res = await api.get('/getItems/class_list/class_desc_lao/id');
      this.classList = res.data;
    },
    async fetchAccdList() {
      const res = await api.get('/getItems/accd/accd/id');
      this.accdList = res.data.sort((a,b) => b.text.localeCompare(a.text));
    },
    async fetchData() {
      if (!this.filters.grade) return;
      try {
        // 1. ດຶງລາຍຊື່ນັກຮຽນກ່ອນ
        const resStudents = await api.get('/students/classlist', {
          params: { Grade_Code: this.filters.grade, school_id: this.user.school_id, accd: this.filters.academicYear, room_no: this.filters.room_no }
        });
        
        // 2. ດຶງຂໍ້ມູນການມາຮຽນທີ່ເຄີຍບັນທຶກໄວ້
        this.filters.school_id = this.user.school_id; // ເພີ່ມ school_id ໃນ filters ເພື່ອໃຊ້ໃນ API
        const resAttendance = await api.get('/attendance/report', { params: this.filters });
        const attendanceMap = new Map(resAttendance.data.rows.map(a => [a.student_id.toString(), a]));

        this.students = resStudents.data.rows.filter(s => s.room_no == this.filters.room_no).map(s => {
          const existing = attendanceMap.get(s._id.toString());
          return {
            ...s,
            status: existing ? existing.status : 'P', // Default to Present
            remarks: existing ? existing.remarks : ''
          }
        });
      } catch (e) { console.error(e); }
    },
    async saveAttendance() {
      this.submitting = true;
      try {
        const payload = {
          ...this.filters,
          data: this.students.map(s => ({
            school_id: this.user.school_id || '',
            student_id: s._id,
            status: s.status,
            remarks: s.remarks
          }))
        };
        const res = await api.post('/attendance/bulk', payload);
        if (res.data.code === 1) alert('ບັນທຶກສຳເລັດ');
      } catch (e) { alert('ເກີດຂໍ້ຜິດພາດ'); }
      finally { this.submitting = false; }
    },
    async exportToExcel() {
      if (this.students.length === 0) {
        alert('ບໍ່ມີຂໍ້ມູນທີ່ຈະສົ່ງອອກ.');
        return;
      }

      try {
        // ສ້າງ Header ສໍາລັບ Excel
        const header = ['ລຳດັບ', 'ລະຫັດນັກຮຽນ', 'ຊື່ ແລະ ນາມສະກຸນ', 'ສະຖານະການມາຮຽນ', 'ໝາຍເຫດ'];
        
        // ຈັດຮູບແບບຂໍ້ມູນນັກຮຽນ
        const data = this.students.map((s, index) => {
          let statusText = 'ມາ';
          if (s.status === 'A') statusText = 'ຂາດ';
          if (s.status === 'L') statusText = 'ລາ';
          
          return [
            index + 1,
            s.student_id,
            `${s.firstNameLao} ${s.familyNameLao}`,
            statusText,
            s.remarks || ''
          ];
        });

        const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Attendance_Report");
        
        // ກຳນົດຊື່ໄຟລ໌ໃຫ້ຊັດເຈນ (ລວມທັງຊັ້ນຮຽນ ແລະ ວັນທີ)
        const dateForFile = this.formattedDate.replaceAll('/', '-');
        const filename = `ລາຍງານການມາຮຽນ_${this.filters.grade}_ຫ້ອງ${this.filters.room_no}_${dateForFile}.xlsx`;
        XLSX.writeFile(wb, filename);
      } catch (error) {
        console.error('Excel Export Error:', error);
        alert('ເກີດຂໍ້ຜິດພາດໃນການສົ່ງອອກໄຟລ໌ Excel');
      }
    }
  }
}
</script>

<style scoped>
.attendance-container { animation: fadeIn 0.4s ease-out; max-width: 1200px; margin: 0 auto; }
.field-row-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }

.attendance-summary { display: flex; gap: 10px; flex-wrap: wrap; }
.badge { padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 700; color: white; }
.badge.present { background: #10b981; }
.badge.absent { background: #ef4444; }
.badge.leave { background: #f59e0b; }

.status-selector { display: flex; background: #f1f5f9; padding: 4px; border-radius: 10px; gap: 4px; }
.status-btn { flex: 1; padding: 8px 15px; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 13px; transition: 0.2s; text-align: center; }
.status-btn input { display: none; }

.status-btn.p.active { background: #10b981; color: white; }
.status-btn.a.active { background: #ef4444; color: white; }
.status-btn.l.active { background: #f59e0b; color: white; }

.remarks-input { border: 1px solid #e2e8f0; padding: 8px; border-radius: 6px; width: 100%; }
.attendance-table th { padding: 15px 12px; background: #f8fafc; border-bottom: 2px solid #e2e8f0; }
.attendance-table td { padding: 12px; border-bottom: 1px solid #edf2f7; vertical-align: middle; }

/* ປັບປຸງຂະໜາດ ແລະ ຮູບແບບຂອງປຸ່ມໃຫ້ໃຫຍ່ ແລະ ສວຍງາມຂຶ້ນ */
.form-actions-wrapper { 
  display: flex; 
  justify-content: flex-end; 
  gap: 15px; 
}

.btn-save, .btn-export {
  padding: 14px 35px; /* ເພີ່ມຂະໜາດ padding ໃຫ້ປຸ່ມໃຫຍ່ຂຶ້ນ */
  font-size: 16px;      /* ເພີ່ມຂະໜາດ font ໃຫ້ອ່ານງ່າຍ */
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: 0.3s;
  border: none;
}

.btn-save { background: var(--lao); color: white; }
.btn-save:hover:not(:disabled) { background: #002d62; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,63,138,0.3); }

.btn-export { background: #10b981; color: white; }
.btn-export:hover:not(:disabled) { background: #059669; transform: translateY(-2px); box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3); }

/* --- Responsive Media Queries --- */

@media (max-width: 1024px) {
  .field-row-4 { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .page-header h1 { font-size: 1.5rem; }
  .panel-head { flex-direction: column; align-items: flex-start; gap: 12px; }
  .attendance-summary { width: 100%; justify-content: flex-start; }
  
  .attendance-table th:nth-child(2), 
  .attendance-table td:nth-child(2) { display: none; } /* ຊ່ອນລະຫັດນັກຮຽນໃນມືຖືເພື່ອປະຢັດເນື້ອທີ່ */
}

@media (max-width: 600px) {
  .field-row-4 { grid-template-columns: 1fr; gap: 15px; }
  
  .form-actions-wrapper {
    flex-direction: column;
    width: 100%;
  }

  .btn-save, .btn-export {
    width: 100%;
    justify-content: center;
    padding: 12px;
    font-size: 15px;
  }
}

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>